<template>
  <div class="bg">
    <el-row>
      <el-col :offset="2" :span="20" class="upd" v-loading="loading">
        <el-row>
          <div style=" margin-left: 3%;height: 60vh;margin-right: 3%">
            <el-row>
              <div class="mygaojian" >全部稿件</div>
            </el-row>
            <el-row style="text-align: left;margin-bottom: 2%">
              <el-radio-group v-model="fType" @change="changeType">
                <el-radio-button label="1">热点图</el-radio-button>
                <el-radio-button label="2">扫码路径图</el-radio-button>
              </el-radio-group>
            </el-row>
            <el-col :span="6" v-for="(item,index) in dataSource" :key="item.id">
              <div class="fileBox" >
                  <i slot="reference" class="el-icon-close hov" style="position: absolute;top: 0;right: 0;z-index: 99" @click="deletePhoto(item.id)"></i>
                <div style="padding-top: 70%;height:0;">
                  <div style="position: absolute;left: 0;top: 0;width: 100%;height: 100%">
                    <div style="height: 80%;background-color: #D9D9D9">
                      <img v-if="fType==1" @click="previewImg(item.fileHotAddress,item.fileName)" :src="item.fileHotAddress" class="imgcl"  alt="访问资源不存在" >
                      <img v-if="fType==2" @click="previewImg(item.filePathAdress,item.fileName)" :src="item.filePathAdress" class="imgcl"  alt="访问资源不存在" >
                    </div>

                    <el-row style="height: 19%">
                      <el-col :span="14" :offset="1" class="flexw" style="height: 100%">
                        <div style="font-size: 13px">{{ item.fileName|ellipsis }}</div>
                      </el-col>
                      <el-col :span="5" style="font-size: 13px;height: 100%" class="flexw">
                        <div>
                          {{ item.uploadTime.substring(2,10) }}
                        </div>
                      </el-col>
                      <el-col :span="3"  style="font-size: 13px;height: 100%" class="flexw">
                        <div>
                          {{ item.uploadTime.substring(11,16) }}
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </el-col>

          </div>
        </el-row>

        <el-pagination style="margin-top: 3%"
          background
          layout="prev, pager, next"
           @current-change="handleCurrentChange"
          :total="total">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="showImageDialog"
      title="图片预览"
      :close-on-click-modal="true"
    >
      <img :src="showImage" alt="图片不存在" style="max-height: 100%;max-width: 100%;margin-bottom: 1%"/>
      <div>文件名:{{showFileName}}</div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "myAccount",

  mounted() {
    let a=localStorage.getItem("userinfo")
    if (a!=undefined &&a!=null){
      this.userId=JSON.parse(localStorage.getItem('userinfo')).userId
    }
    this.getFileData()
  },
  data() {
    return {
      userId:"",
      fType:"1",//展示文件类别 1热力图 2 路径图
      currentPage: 1,
      pageSize: 8,
      total:0,
      dataSource:{},
      loading:false,
      visible:false,
      showImageDialog:false,
      showImage:"",
      showFileName:""
    }
  },
  methods: {
    changeType(val){
     this.fType=val
      this.currentPage=1
      this.getFileData()
    },
    getFileData() {
      this.loaditme = true
      let params = {}
      params.currentPage = this.currentPage
      params.pageSize = this.pageSize
      params.userId=this.userId
      if (this.fType=="1"){
        params.hotStatus=1
      }else if (this.fType="2"){
        params.pathStatus=1
      }
      this.loading=true
      this.$axios.post('/api/uploadfile/selectFileInfoByUserId', params).then(res => {
        if (res.data.status == 0) {
          this.total = res.data.total
          this.dataSource = res.data.data.files
        } else {
          this.$message({
            message: res.data.message,
            duration: 2000,
            type: 'warning'
          });
        }
        this.loading=false
      }).catch(error => {
        this.$message.error('查询失败！');
        this.loading=false
        return false
      });
    },
    handleCurrentChange(val){
      this.currentPage=val
      this.getFileData()
    },
    deletePhoto(id){
      let params = {}
      params.id=id
      this.$axios.post('/api/uploadfile/deleteUploadFileById', params).then(res => {
        if (res.data.status == 0) {
          this.$message({
            message: res.data.message,
            duration: 1500,
            type: 'success'
          });
          this.getFileData()
        } else {
          this.$message({
            message: res.data.message,
            duration: 2000,
            type: 'warning'
          });
        }
        this.loading=false
      }).catch(error => {
        this.$message.error('删除失败！'+error);
        return false
      });
    },
    previewImg(src,fileName){
      this.showImageDialog=true
      this.showImage=src
      this.showFileName=fileName
    }
  },
  filters: {
    // 当标题字数超出时，超出部分显示“...”
    ellipsis (docName) {
      if (!docName) return ''
      if (docName.length > 10) {
        return docName.slice(0, 10) + '...'
      }
      return docName
    }
  },
}
</script>

<style scoped>
.bg {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.mygaojian {
  height: 2.1354rem;
  /*padding-top: 0.9896rem;*/
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 1.25rem;
  /*line-height: 1.1458rem;*/
  color: #565656;
  /*margin-left: 1.875rem;*/
  text-align: left;
}
.upd {
  margin-top: 3vh;
  /*height: 20vh;*/
  background-color: #ffffff;
  box-shadow: 0 0 0.6813rem rgba(0, 0, 0, .1);
  padding-top:2vh;
  min-height: 85vh;
  position: relative;
}
.flexw{
  display: flex;
  align-items: center;
}
.fileBox{
  width: 96%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  position: relative;
  margin-right: 4%;
  box-sizing: border-box;
  margin-bottom: 5%;
  border-radius: 3%;
}
.el-col-25{
  width: 20% !important;
}
.hov:hover{
  cursor: pointer;
}
.imgcl{
  max-width: 100%; max-height: 100%;box-sizing: border-box;display: block;margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/account/myAccount.vue